import React , { useState, useEffect, useContext } from 'react';
import { Route, Switch, withRouter, Link, useHistory, useRouteMatch } from 'react-router-dom'
import axios from "axios"; 
import { Modal } from 'react-responsive-modal';
import { useTranslation } from 'react-i18next';
// import {OrganizationContext} from "../../Shared/OrganizationContext.js";
// import {UserContext} from "../../Shared/UserContext.js";
import { TaskFormContext } from "./TaskFormContext.js";

const AiForm = ({setChoosePath, setUseAi}) => {
  // const {organizationAuthorizations} = useContext(OrganizationContext);
  // const currentUser = useContext(UserContext);
  const {setAiGenerated, setSections} = useContext(TaskFormContext);
  const { t } = useTranslation();
  const history = useHistory();
  const match = useRouteMatch();
  const [loaded, setLoaded] = useState(false)
  const [disabled, setDisabled] = useState(false);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [generating, setGenerating] = useState(false);
  
  const [examples, setExamples] = useState([
    {
      "Title": "Request a video editing service",
      "Description": "Create a form to collect all necessary information from a client who has purchased a video editing service. Include fields for uploading raw footage, brand assets, and any audio. Ask for video length, platform (e.g. YouTube, Instagram), editing style (cinematic, corporate, fast-paced), music preferences, whether captions/subtitles are needed, references for inspiration, and deadline."
    }, 
    {
      "Title": "Request a logo design",
      "Description": "Generate a form to gather logo design requirements from a client. Ask for the business name and tagline, a description of the brand or industry, color and style preferences, icons or symbols to include, where the logo will be used, inspiration examples (file upload or links), required formats, and timeline."
    },
    {
      "Title": "Request a social media post",
      "Description": "Build a form for a client requesting a social media post. Include fields for the platform (e.g. Instagram, LinkedIn), the post's topic or purpose, caption text or bullet points, visual style (e.g. branded, casual, meme-style), image or video uploads, posting date/time, hashtags to include, and call-to-action."
    },
    {
      "Title": "Request a website design",
      "Description": "Create a detailed form for clients requesting a website design. Ask for the website's purpose (e.g. portfolio, e-commerce), page list and names, brand colors, fonts, and logo uploads, preferred design style, website examples they like, required features (e.g. booking, forms, blog), target audience, launch deadline, and any available content (text, images, video)."
    },
    {
      "Title": "Onboarding form for new clients",
      "Description": "Generate a client onboarding form for a creative agency. Include fields for point of contact name and email, business name and industry, services purchased, communication preferences, key deadlines, asset uploads (e.g. brand kit, style guide), access credentials (optional), and an open text field for any additional notes."
    }
  ]);

  const handleSubmit = (evt) => {
    evt.preventDefault();
    setDisabled(true);
    setGenerating(true);

    axios.post(`/api/openai_task_form_generator_2`, {
      description: description
    })
    .then(function(response){
      console.log(response);
      setSections(JSON.parse(response.data.response.choices[0].message.content).sections);
      setAiGenerated(true);
      setChoosePath(false);
      if(response.data.success){
      } else {
        response.data.errors.forEach((error) => {
          notice(error);
        });
      }
    })
    .catch(function(error){
      console.log(error)
      notice("An error occured");
      reportError(`File: Status.js.requestUrl: ${error.config.url}. StackTrace: ${error.stack}.`);
    })
    .then(function () {
      setDisabled(false);
      setGenerating(false);
    });
  }

  const examples_list = examples.map((example) => {
    return(
      <div className="badge badge-blue cursor-pointer opacity-7 opacity-10-hover" onClick={() => setDescription(example.Description)}>{example.Title}</div>
    )
  });

  return(
    <React.Fragment>
      <div className="display-flex">
        <a className="color-1 btn btn-small background-hover opacity-5 opacity-10-hover" onClick={() => setUseAi(false)}>
          <i className="fas fa-arrow-left"></i> Back
        </a>
      </div>

      <div className="large-padding">
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>Describe what the client will be requesting</label>
            <div className="textarea-gradient-border">
              <textarea 
                autoFocus
                className="form-control textarea-gradient-content" 
                rows="4" 
                placeholder="e.g. This form is for submitting a new request for a video editing service for youtube reels. " 
                value={description} 
                onChange={(e) => setDescription(e.target.value)} 
              />
            </div>

            <div className="mt-15 display-flex gap-8 flex-wrap">
              {examples_list}
            </div>
          </div>

          <div className="field text-right">
            <button disabled={disabled || !description} type="submit" className="btn btn-primary">
              {generating ? <><i className="fas fa-spinner fa-spin"></i> Generating...</> : "Generate form"}
            </button>
          </div>
        </form>
      </div>
    </React.Fragment>
  )
}

export default AiForm;